import { FormControlLabel, Switch, SwitchProps } from '@mui/material'
import { FieldContainer } from '../functional'
import styled from '@emotion/styled'
import { color } from '../../styles'

interface SwitchFieldProps {
   name: string
   label?: string
   size?: 'small' | 'medium'
   disabled?: boolean
}

const SwitchField: React.FC<SwitchFieldProps> = ({ label, name, size, disabled }) => {
   return (
      <FieldContainer name={name}>
         {({ helperText, error, ...fieldProps }) => (
            <FormControlLabel
               label={label}
               name={name}
               control={
                  <IOSSwitch
                     {...fieldProps}
                     onChange={(e) => {
                        fieldProps.onChange({ target: { name, value: e.target.checked } })
                     }}
                     checked={fieldProps.value}
                     disabled={disabled}
                     className={size}
                  />
               }
               style={{ userSelect: 'none' }}
            />
         )}
      </FieldContainer>
   )
}

const IOSSwitch = styled((props: SwitchProps) => (
   <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(() => ({
   width: 42,
   height: 26,
   padding: 0,
   marginRight: 20,
   marginLeft: '1.5em',
   marginTop: '1.2em',
   '&.medium': {
      transform: `scale(${1.5})`,
   },
   '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
         transform: 'translateX(16px)',
         color: '#fff',
         '& + .MuiSwitch-track': {
            backgroundColor: color.green,
            opacity: 1,
            border: 0,
         },
         '& .MuiSwitch-thumb': {
            backgroundColor: color.white + ' !important',
         },
         '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.5,
         },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
         color: color.green,
         border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
         color: color.grayLight,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
         opacity: 0.7,
      },
   },
   '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 22,
      height: 22,
   },
   '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      backgroundColor: '#E9E9EA',
      opacity: 1,
      transition: 'background-color 0.3s ease-in-out',
   },
}))

export default SwitchField
